import React from 'react';
import { PropTypes } from 'prop-types';
import { keyBy, values } from 'lodash';
import { Heading, Text, FlexRow, FlexCol, Stack } from 'sarsaparilla';
import AnimalItem from './AnimalItem';
import { DOGS_OR_OTHER_PETS } from '../../../ui-inyonwhitney/src/utils/inyoUtils';

const propTypes = {
    animals: PropTypes.any,
    handleAnimalsChange: PropTypes.func,
    permit: PropTypes.any,
    maxQuota: PropTypes.number,
    additionalInstructions: PropTypes.string,
};

export default class AnimalList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { animalTotal: 0 };
    this.handleAnimalChange = this.handleAnimalChange.bind(this);
  }

  componentDidMount() {
    const animalTotal = this.computeAnimalTotal(this.props.animals);
    this.setState({ animalTotal })
  }

  handleAnimalChange(idx, input) {
    const animalMap = keyBy([...this.props.animals], 'type');
    animalMap[input.type] = { index: idx, type: input.type, amount: input.amount };
    const newAnimals = values(animalMap);
    const animalTotal = this.computeAnimalTotal(newAnimals);

    // if the number is not greater than max
    if (animalTotal <= this.props.maxQuota || this.props.maxQuota == null) {
      this.setState({ animalTotal });
      this.props.handleAnimalsChange(newAnimals);
    }
  }

  computeAnimalTotal(animals) {
    if (animals) {
      return animals.reduce((total, animal) => {
        return total + parseInt(animal.amount, 10);
      }, 0);
    }

    return 0;
  }

  renderAnimalList() {
    const remainingQuantity = Math.max(this.props.maxQuota - this.state.animalTotal, 0);

    return this.props.animals
      ? this.props.permit.animals
          .filter((it) => it.type !== DOGS_OR_OTHER_PETS)
          .map((item, index) => {
            const found = this.props.animals.find((it) => it.type === item.type);
            const animal = { ...item };
            if (found) {
              animal.amount = found.amount;
            }

            return (
              <AnimalItem
                permit={this.props.permit}
                key={animal.type}
                animal={animal}
                index={index}
                maxAnimalQuantity={animal.amount + remainingQuantity}
                handleAnimalChange={this.handleAnimalChange}
              />
            );
          })
      : [];
  }

  render() {
    const totalAnimals = Number.isInteger(this.props.maxQuota) ? this.props.maxQuota : 'Unlimited';
    return (
      <FlexRow id="animal-list-shared-component">
        <FlexCol xs={12} className="mb-2">
          <Heading headingLevel={2} appearance="h5">Stock</Heading>
        </FlexCol>
          {
              totalAnimals > 0 &&
                  <>
                    <FlexCol xs={12} className="mb-2">
                      <Text> Enter the type & number of stock you will be bringing. <b>{this.props.additionalInstructions}</b></Text>
                      <Text>
                          Total Animals:
                          <b>
                            {` ${this.state.animalTotal} / ${totalAnimals}`}
                          </b>
                      </Text>
                    </FlexCol>
                    <FlexCol>
                      <Stack>
                        {this.renderAnimalList()}
                      </Stack>
                    </FlexCol>
                  </>
          }
          {
              totalAnimals <= 0 &&
                  <FlexCol xs={12} className="mb-2">
                      <Text>
                          Stock are not allowed on your trip because one or more of your selected locations does not allow stock.
                      </Text>
                  </FlexCol>
          }
      </FlexRow>
    );
  }
}

AnimalList.propTypes = propTypes;
